import { extractCityAndState } from '~/utils/extractCityAndState';

export async function getCityFromCoords(lat, lon) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  const response = await fetch(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}`
  );
  const data = await response.json();

  const firstResult = data.results[0];

  const { city, state } = extractCityAndState(
    firstResult?.address_components || []
  );

  return { city, state };
}
